"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStudioResultFactory = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const constants_1 = require("./constants");
class AppStudioResultFactory {
    static UserError(name, messages, helpLink, stack, innerError) {
        return new teamsfx_api_1.UserError({
            name,
            message: messages[0],
            displayMessage: messages[1],
            source: constants_1.Constants.PLUGIN_NAME,
            helpLink,
            error: innerError,
        });
    }
    static SystemError(name, messages, innerError, stack, issueLink) {
        return new teamsfx_api_1.SystemError({
            name,
            message: messages[0],
            displayMessage: messages[1],
            source: constants_1.Constants.PLUGIN_NAME,
            issueLink,
            error: innerError,
        });
    }
}
exports.AppStudioResultFactory = AppStudioResultFactory;
AppStudioResultFactory.defaultHelpLink = "";
AppStudioResultFactory.defaultIssueLink = "";
//# sourceMappingURL=results.js.map